/** @format */

import React, { useContext, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { useTranslation } from "react-i18next";
import Tooltip from "../../Components/Common/Tooltip";
import { roles } from "../../Config/Roles";
import { AuthContext } from "../../Contexts/AuthContext";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { cardServices } from "../../Services/card.services";
import ActionModal from "../Common/ActionModal";
import ResultModal from "../Common/ResultModal";
import SpinnerLoading from "../Common/SpinnerLoading";
import AddCardType from "./AddCardType";
import UpdateCardType from "./UpdateCardType";

const Index = () => {
  const { t: translator } = useTranslation();
  const { updateLocName } = useContext(GlobalContext);
  const { roleId } = useContext(AuthContext);
  const { master, admin, support } = roles;

  const isActionAllowed = [master, admin, support].includes(parseInt(roleId));

  const { SearchBar } = Search;

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [updateData, setUpdateData] = useState(null);
  const [update, setUpdate] = useState(new Date());

  const [resultModal, setResultModal] = useState({
    show: false,
    title: "",
    text: "",
    btnClass: "",
  });

  const [actionModal, setActionModal] = useState({
    show: false,
    title: "",
    text: "",
    confirmBtn: "",
  });

  useEffect(() => updateLocName("card-types"), []);
  useEffect(() => {
    setIsLoading(true);
    cardServices
      .getAllCards()
      .then((res) => {
        setData(res.data.data);
        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  }, [update]);

  const onClickDelete = (rowId) => {
    setActionModal({
      show: true,
      title: "CardTypes-Delete-Title",
      text: "CardTypes-Delete-Text",
      confirmBtn: "CardTypes-Delete-Btn",
      confirmAction: () => confirmDelete(rowId),
    });
  };

  function actionFormatter(rowId) {
    return (
      <div
        className="action"
        onClick={(e) => {
          e.stopPropagation();
          onClickDelete(rowId);
        }}
      >
        <span className="icon icon-cancel" style={{ color: "#c00" }}></span>
      </div>
    );
  }

  const columns = [
    {
      dataField: "creditCardId",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      formatter: actionFormatter,
      hidden: !isActionAllowed,
      // hidden: [cashier, accountant].includes(Number(roleId)) ? true : false,
    },
    {
      dataField: "name",
      text: translator("Administration-CardTypes-CardName"),
    },
  ];
  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      if (updateData == row) {
        setUpdateData(null);
      } else {
        setUpdateData(row);
      }
    },
  };

  const confirmDelete = (id) => {
    cardServices
      .deleteCard(id)
      .then((data) => {
        setActionModal({ ...actionModal, show: false });
        setResultModal({
          ...resultModal,
          title: translator("CardTypes-ResultModal-DeleteSuccess-Title"),
          text: translator("CardTypes-ResultModal-DeleteSuccess-Text"),
          show: true,
          btnClass: "btn btn-primary",
        });
        setUpdate(new Date());
      })
      .catch((err) =>
        setResultModal({
          ...resultModal,
          title: translator("CardTypes-ResultModal-DeleteSuccess-Title"),
          text: translator("CardTypes-ResultModal-DeleteUnSuccess-Text"),
          show: true,
          btnClass: "btn btn-primary",
        })
      );
  };

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("CardTypes-View-Subtitle")}</span>
        </div>
        <div className="card-body ">
          <ToolkitProvider
            keyField="creditCardId"
            data={data}
            columns={columns}
            search
          >
            {(props) => (
              <>
                <div className="row">
                  <div className="col-md-6 col-sm-12 mt-2">
                    {isLoading ? (
                      <div className="dashboard-card-spinner">
                        <SpinnerLoading />
                      </div>
                    ) : (
                      <>
                        <div className="d-flex justify-content-between align-items-end">
                          <div>
                            <div>
                              <label>{translator("PayOption-View-Name")}</label>
                              <Tooltip
                                text={translator("PayOptionTooltip-Msg")}
                              />
                            </div>
                            <SearchBar {...props.searchProps} />
                          </div>
                        </div>
                        <BootstrapTable
                          {...props.baseProps}
                          rowClasses="boostrap-table-row"
                          rowEvents={rowEvents}
                          noDataIndication={translator("No-Data")}
                          pagination={paginationFactory({})}

                          // onTableChange={onTableChange}
                        />
                      </>
                    )}
                  </div>

                  <div className="col-md-6 col-sm-12 mt-2">
                    {!updateData && (
                      <AddCardType
                        onSuccess={() => {
                          setUpdate(new Date());
                          setUpdateData(null);
                        }}
                        disabled={!isActionAllowed}
                        setResultModal={setResultModal}
                      />
                    )}
                    {updateData && (
                      <UpdateCardType
                        updateData={updateData}
                        disabled={!isActionAllowed}
                        onSuccess={() => {
                          setUpdate(new Date());
                          setUpdateData(null);
                        }}
                        setResultModal={setResultModal}
                      />
                    )}
                  </div>
                </div>
              </>
            )}
          </ToolkitProvider>
        </div>
      </div>

      <ResultModal
        show={resultModal.show}
        title={resultModal.title}
        text={resultModal.text}
        btnClass={resultModal.btnClass}
        handleClose={() => {
          setResultModal({ ...resultModal, show: false });
          setUpdateData(null);
        }}
      />

      <ActionModal
        show={actionModal.show}
        handleHide={() => {
          setActionModal({ ...actionModal, show: false });
        }}
        title={actionModal.title}
        text={actionModal.text}
        confirmBtn={actionModal.confirmBtn}
        confirmAction={actionModal.confirmAction}
      />
    </div>
  );
};

export default Index;
